<template>
    <div class="card card-with-shadow border-0 pb-primary">
        <div class="card-header d-flex align-items-center p-primary primary-card-color">
            <h5 class="card-title d-inline-block mb-0">{{ $t(title) }}</h5>
            <app-search @input="getSearchValue"/>
        </div>
        <div class="p-primary d-flex align-items-center primary-card-color">
            <ul class="nav tab-filter-menu justify-content-flex-end">
                <li class="nav-item" v-for="(item, index) in userFilterOptions" :key="index">
                    <a href="#"
                       class="nav-link py-0 font-size-default"
                       :class="[value == item.id ? 'active' : index === 0 && value === '' ? 'active': '']"
                       @click="getFilterValue(item.id)">
                        {{ item.translated_name }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-body px-primary">
            <app-table :id="data.tableId"
                       class="remove-datatable-x-padding"
                       :options="userTableOptions"
                       :filtered-data="filteredData"
                       :search="search"
                       @action="action"/>
        </div>
    </div>
</template>

<script>
    import {TableMixin} from '../Mixins/TableMixin';
    import * as actions from '../../../../Config/ApiUrl';

    export default {
        name: "User",
        mixins: [TableMixin],
        props: {
          title: String,
        },
        data() {
            return {
                value: '',
                filteredData: {},
                userTableOptions: {
                    name: 'Users',
                    url: actions.USERS,
                    tablePaddingClass: 'pt-0',
                    datatableWrapper: false,
                    showHeader: false,
                    tableShadow: false,
                    columns: [
                        {
                            title: this.$t('user'),
                            type: 'custom-html',
                            key: 'full_name',
                            isVisible: true,
                            modifier: (value, row) => {
                                const imgPath = row.image ? row.image.path : '';
                                const initials = ((row.first_name || '').charAt(0) + (row.last_name || '').charAt(0)).toUpperCase();
                                const avatar = imgPath
                                    ? `<img src="${imgPath}" class="rounded-circle avatars-w-50" style="width:40px;height:40px;object-fit:cover;" alt="${initials}">`
                                    : `<div class="rounded-circle avatars-w-50 d-flex align-items-center justify-content-center text-white font-weight-bold"
                                            style="width:40px;height:40px;background:#6c757d;font-size:14px;flex-shrink:0;">${initials}</div>`;

                                const companies = row.nameWithCompany
                                    ? row.nameWithCompany.match(/\(([^)]+)\)/)
                                    : null;
                                const companyName = companies ? companies[1] : '';
                                const fullName = (row.first_name || '') + ' ' + (row.last_name || '');
                                const star = row.is_company_admin
                                    ? ` <span title="Company Admin" style="color:#f5a623;font-size:15px;vertical-align:middle;text-shadow:0 1px 3px rgba(245,166,35,0.5);">&#9733;</span>`
                                    : '';

                                return `<div class="media align-items-center">
                                            ${avatar}
                                            <div class="media-body ml-3">
                                                <span style="font-weight:500;">${fullName}</span>${star}
                                                <span style="color:#6c757d;"> (${companyName})</span>
                                                <p class="mb-0 text-muted" style="font-size:13px;">${row.email || ''}</p>
                                            </div>
                                        </div>`;
                            }
                        },
                        {
                            title: this.$t('status'),
                            type: 'custom-html',
                            key: 'status',
                            isVisible: true,
                            modifier: (value, row) => {
                                let badge = `<div class="d-flex flex-column align-items-center">
                                                <span class="badge badge-sm badge-pill badge-${value.class}">${value.translated_name}</span>`;
                                if (row.id === this.$store.state.user.loggedInUser.id) {
                                    badge += `<span class="badge badge-sm badge-pill badge-warning mt-2 px-3 shadow-sm" 
                                                    style="font-size: 85%; border: 1px solid #e67e22; min-width: 60px;">
                                                    (You)
                                              </span>`;
                                }
                                badge += `</div>`;
                                return badge;
                            }
                        },
                        {
                            title: this.$t('action'),
                            type: 'action',
                            key: 'invoice',
                            isVisible: true
                        },
                    ],
                    showSearch: false,
                    showFilter: false,
                    paginationType: 'pagination',
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: 'desc',
                    actionType: "dropdown",
                    actions: [
                        {
                            title: this.$t('edit'),
                            type: 'none',
                        },
                        {
                            title: this.$t('delete'),
                            type: 'none',
                        },
                        {
                            title: this.$t('active'),
                            type: 'none',
                            modifier: (row) => {
                                const {status} = row;
                                return status.name != "status_invited" && status.name != "status_active" ? true : false;
                            }
                        },
                        {
                            title: this.$t('de_activate'),
                            type: 'none',
                            modifier: (row) => {
                                const {status} = row;
                                return status.name != "status_invited" && status.name != "status_inactive" ? true :false;
                            }
                        },
                        {
                            title: this.$t('manage_role'),
                            type: 'none',
                        },
                        {
                            title: this.$t('assign_forms'),
                            type: 'none',
                        },
                    ],
                },
                userFilterOptions: [
                    {id: '', name: 'all_users', translated_name: 'All Users'}
                ],
            }
        },
        mounted(){
            this.getStatuses();
        },
        methods: {
            getFilterValue(item) {
                this.value = item;
                this.filteredData['status-id'] = item;
                this.$hub.$emit('reload-' + this.data.tableId);
            },
            getStatuses(){
                let url = `${actions.GET_STATUSES}?type=user`;

                this.axiosGet(url).then(response => {

                    this.userFilterOptions = [...this.userFilterOptions, ...response.data];

                }).catch(({response}) => {

                }).finally(() => {

                });
            }
        }
    }
</script>
